import { useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import withUsageTracking from '../hoc/withUsageTracking';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { SearchIcon } from 'foundations-assets/icons/components/SearchIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const EPSpotlightButton = ({
  'data-test-id': dataTestId = 'spotlight-button',
  Icon = SearchIcon,
  iconSize = '300',
  onClick,
  onTrackUsage,
  size = 'small',
  tooltipKey = 'epSpotlight.openSpotlightButton'
}) => {
  const handleClick = useCallback(() => {
    onClick();
    onTrackUsage('open quickspot via click');
  }, [onClick, onTrackUsage]);
  return /*#__PURE__*/_jsx(IconButton, {
    "data-test-id": dataTestId,
    onClick: handleClick,
    size: size,
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: tooltipKey
    }),
    children: /*#__PURE__*/_jsx(Icon, {
      size: iconSize
    })
  });
};
export { EPSpotlightButton };
export default withUsageTracking(EPSpotlightButton);